export const ALL_PAGES_PAGINATION = -1;
